import { Directive, Input, SimpleChanges, TemplateRef, ViewContainerRef } from '@angular/core';
import { PROFILE, PROFILE_ACCESS } from '@app/config/role-name.enum';

@Directive({
  selector: '[appHasAccessInterview]'
})
export class HasAccessInterviewDirective {

  private currentTemplate: 'mainTemplate' | 'elseTemplate' | '' = '';

  @Input() userProfile: PROFILE;
  @Input() hasCreditsInterview: boolean = null;

  @Input() set appHasAccessInterviewElse(elseTemplateRef: TemplateRef<any>) {
    this.elseTemplateRef = elseTemplateRef;
  }

  private elseTemplateRef: TemplateRef<any> | null = null;

  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef
  ) { }

  ngOnChanges(changes: SimpleChanges) {


    if (changes['userProfile'] || changes['hasCreditsInterview']) {
      this.applyStyles();
    }
  }

  applyStyles() {

    const validationPremium = PROFILE_ACCESS[this.userProfile]?.validationPremium;

    if (!Array.isArray(validationPremium)) {

      this.actionChangeView(false);
      return;
    }

    if (validationPremium.includes('interview') && this.hasCreditsInterview === false) {
      this.actionChangeView(false);
      return;
    }

    this.actionChangeView(true);
  }

  actionChangeView(isVisible: boolean) {

    if (isVisible) {

      if (this.currentTemplate === 'mainTemplate')
        return;

      this.viewContainer.clear();
      this.viewContainer.createEmbeddedView(this.templateRef);
      this.currentTemplate = 'mainTemplate';
      return;
    }

    if (this.currentTemplate === 'elseTemplate')
      return;

    this.viewContainer.clear();
    this.viewContainer.createEmbeddedView(this.elseTemplateRef);
    this.currentTemplate = 'elseTemplate';
  }
}
